import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <HeroSection />

        <ContactSection />

        <FeaturesSection />

        <TopicsSection />

        <FaqSection />

        <CarouselSection />

        <CardsSection />

        <AboutSection />

        <MediaSection />

        <AppSection />

        <RankingSection />

        <IndexSection />

        <CommentsSection />

        <UpdatesSection />
      </main>

      <Footer />
    </div>
  );
}